import React, { useState, useEffect } from "react";
import { Toast, Button, HeaderText, RefundCard } from "..";
import { useNavigate, Link } from "react-router-dom";
import { useOrderContext, useAppContext } from "../../contexts";
import { useSelector, useDispatch } from "react-redux";
import { updateRefundSettingsDetails } from "../../redux/slices";
import { refundSettingsActionTypes } from "../../redux/utils";
import { useHardCode, useAPI } from "../../hooks";
export const RefundOptions = () => {
  const { setIsSelected } = useOrderContext();
  const [refundType, setRefundType] = useState();
  const [refundOption, setRefundOption] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const navigate = useNavigate();
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const dispatch = useDispatch();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const { GET_RETURN_PAYMENT_INFO } = useAPI();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const get_extra = isPureFemale
    ? PURE_FEMALE_TRANSLATION.refund_options.get_extra
    : storeConfigState?.themeConfig?.get_extra;
  const store_credit = isPureFemale
    ? PURE_FEMALE_TRANSLATION.refund_options.store_credit
    : storeConfigState?.themeConfig?.store_credits;
  const minus_charges = isPureFemale
    ? PURE_FEMALE_TRANSLATION.refund_options.minus_any_charges
    : storeConfigState?.themeConfig?.minus_any_charges;

  /*it will decide whether to  navigate to page where user fill there bank ac detail*/

  const isNavigateToBankAccountInfo =
    productDetailsState.paymentMethod.toUpperCase() === "COD" &&
    productDetailsState.originalPaymentMethodRefundAvailable &&
    productDetailsState.askAccountInformation &&
    (productDetailsState.allowCustomerBankDetails ||
      productDetailsState.allowCustomerUpiDetails);

  /* Refund Option and there detail is setting up */
  const refundOptionItems = [
    {
      id: 1,
      name: storeConfigState?.themeConfig
        ?.refund_method_page_store_credit_card_title,
      desc: storeConfigState?.themeConfig
        ?.refund_method_page_store_credit_card_content,
      isEnable: true,
      isShow: selectedProductDetailsState.storeCreditApplicable,
    },
    {
      id: 2,
      name: storeConfigState?.themeConfig
        ?.refund_method_page_original_payment_card_title,
      desc: storeConfigState?.themeConfig
        ?.refund_method_page_original_payment_card_content,
      isEnable: true,
      isShow: selectedProductDetailsState.originalPaymentApplicable,
    },
  ];
  const isShowCredit = refundSettingsState?.incentive
    ?.return_refund_store_credits?.refund_value?.additional_store_credits
    ? true
    : false;
  const buttonHandler = () => {
    setIsBtnDisabled(true);
    dispatch(
      updateRefundSettingsDetails({
        key: refundSettingsActionTypes.UPDATE_REFUND_OPTION,
        value: refundOption,
      })
    );
    if (
      refundType ===
      storeConfigState?.themeConfig
        ?.refund_method_page_original_payment_card_title
    ) {
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_THANKYOU_HEADING,
          value:
            storeConfigState?.themeConfig
              ?.return_submission_original_payment_left_title,
        })
      );

      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING,
          value:
            storeConfigState?.themeConfig
              ?.return_submission_original_payment_right_card_title,
        })
      );

      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT,
          value:
            refundSettingsState?.incentive?.return_refund_store_credits
              ?.refund_value,
        })
      );

      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION,
          value:
            storeConfigState?.themeConfig
              ?.return_submission_original_payment_right_card_subtitle,
        })
      );
    }

    dispatch(
      updateRefundSettingsDetails({
        key: refundSettingsActionTypes.UPDATE_REFUND_METHOD,
        value: storeConfigState?.themeConfig?.original_payment_method,
      })
    );
    dispatch(
      updateRefundSettingsDetails({
        key: refundSettingsActionTypes.UPDATE_TOTAL_REFUND,
        value:
          refundSettingsState?.incentive?.return_refund_store_credits
            ?.refund_value?.order_value_store_credits,
      })
    );

    if (
      isNavigateToBankAccountInfo &&
      refundType ===
        storeConfigState?.themeConfig
          ?.refund_method_page_original_payment_card_title
    ) {
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
          value: "ORIGINAL_PAYMENT",
        })
      );
      navigate("/Cod");
    } else {
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_REFUND_METHOD,
          value: storeConfigState?.themeConfig?.original_payment_method,
        })
      );
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_TOTAL_REFUND,
          value:
            refundSettingsState?.incentive?.return_refund_store_credits
              ?.refund_value?.order_value_store_credits,
        })
      );
      if (
        refundType ===
        storeConfigState?.themeConfig
          ?.refund_method_page_original_payment_card_title
      ) {
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
            value: "ORIGINAL_PAYMENT",
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_REFUND_METHOD,
            value: storeConfigState?.themeConfig?.original_payment_method,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_TOTAL_REFUND,
            value:
              refundSettingsState?.incentive?.return_refund_store_credits
                ?.refund_value?.order_value_store_credits,
          })
        );
      } else if (
        refundType ===
        storeConfigState?.themeConfig
          ?.refund_method_page_store_credit_card_title
      ) {
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
            value: "STORE_CREDIT",
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_REFUND_METHOD,
            value: storeConfigState?.themeConfig?.store_credits,
          })
        );
        dispatch(
          updateRefundSettingsDetails({
            key: refundSettingsActionTypes.UPDATE_TOTAL_REFUND,
            value:
              parseInt(
                refundSettingsState?.incentive?.return_refund_store_credits
                  ?.refund_value?.additional_store_credits
              ) +
              parseInt(
                refundSettingsState?.incentive?.return_refund_store_credits
                  ?.refund_value?.order_value_store_credits
              ),
          })
        );
      }
      (async () => {
        setIsLoader(true);
        setIsBtnDisabled(true);
        if (
          refundSettingsState.refundReviewRoute === "STORE_CREDIT" ||
          refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
        ) {
          try {
            const VariantID = selectedProductDetailsState.variantID;
            const productID = selectedProductDetailsState.productID;
            const StoreUniqueID = storeConfigState.storeUniqueID;
            const OrderInfo = productDetailsState.orderInfo;
            const customerID = OrderInfo.customer_id;
            const response = await fetch(GET_RETURN_PAYMENT_INFO, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                test_mode: productDetailsState.testMode,
                store_name: StoreUniqueID,
                email: productDetailsState.customerEmail,
                order_number: productDetailsState.orderNumber,
                order_id: productDetailsState.recentOrderID,
                customer_id: customerID,
                variant_id: VariantID,
                product_id: productID,
                refund_to: refundSettingsState.refundOption,
                is_refund: true,
                image_list: exchangeSettingsState.imageList,
                reason_id: productDetailsState.returnReasonID,
                other_reason_desc: productDetailsState.reasonDetails,
                sub_reason_detail: productDetailsState.subReasonDetails,
                line_item_id: selectedProductDetailsState.lineItemID,
                quantity: parseInt(selectedProductDetailsState.selectedQuantity),
                access_code: otherSettingsState.accessCode,
                incentive: refundSettingsState.incentive,
                customer_data: productDetailsState.customerInfo,
              }),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (response.ok) {
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_AMOUNT,
                  value: data?.payment_amount,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_GATEWAY_INFO,
                  value: data?.payment_gateway_info,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_LINK,
                  value: data?.payment_link,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_REQUIRED,
                  value: false,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_PAYMENT_ID,
                  value: "",
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH,
                  value: data?.collect_payment_through,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_DETAILS,
                  value: data,
                })
              );
    
              setIsLoader(false);
              setIsBtnDisabled(false);
              navigate("/ReturnReview");
            }
          } catch (error) {
            setIsInternalServerError(true);
          }
        }
      })();
    }
  };
  /* navigate to previous page */
  const backHandler = () => {
    window.history.back();
  };

  /* Hot fix for Refund Issue */
  const getRefundOptionValue = (itemID) => {
    if (itemID === 1) {
      setRefundOption("store_credit");
    } else {
      setRefundOption("original_payment_method");
    }
  };

  useEffect(() => {
    if (
      refundType ===
      storeConfigState?.themeConfig
        ?.refund_method_page_original_payment_card_title
    ) {
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
          value: "ORIGINAL_PAYMENT",
        })
      );
    } else if (
      refundType ===
      storeConfigState?.themeConfig?.refund_method_page_store_credit_card_title
    ) {
      dispatch(
        updateRefundSettingsDetails({
          key: refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE,
          value: "STORE_CREDIT",
        })
      );
    }
  }, [refundType]);
  return (
    <div className="saara-item-container">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara-item-heading">
        <div>
          <Link to="" onClick={backHandler} className="backIcon">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
        </div>

        <HeaderText
          text={storeConfigState?.themeConfig?.refund_method_page_title}
        />
      </div>
      <div className="refund-card-container">
        {refundOptionItems.map(
          (item) =>
            item.isShow && (
              <RefundCard
                heading={item.name}
                description={item.desc}
                key={item.id}
                isShowCredit={isShowCredit}
                itemID={item.id}
                productDetailsState={productDetailsState}
                refundSettingsState={refundSettingsState}
                minus_charges={minus_charges}
                store_credit={store_credit}
                get_extra={get_extra}
                isChecked={refundType === item.name && item.isEnable}
                onClick={() => {
                  setRefundType(item.name);
                  setIsSelected(true);
                  getRefundOptionValue(item.id);
                  setIsBtnDisabled(false);
                }}
              />
            )
        )}
      </div>
      <div className="btns">
        <div className=" btn__big_screen margin-right-20">
          <button
            className="saara_custom_btn saara__btn btn__back back-page"
            onClick={backHandler}
          >
            {storeConfigState?.themeConfig?.back_button_label}
          </button>
        </div>
        <div>
          <Button
            name={
              isLoader ? (
                <div
                  className="saara-spinner-border saara-spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                storeConfigState?.themeConfig?.continue_button_label
              )
            }
            onClick={buttonHandler}
            disabled={isBtnDisabled}
          />
        </div>
      </div>
    </div>
  );
};
